import React from 'react';
import { GOOGLE_MAP_API_KEY } from '../../../config';
import Loader from '../loader/Loader';

// withGoogleMaps is a higher-order component. It doesn't render the given component until the Google Maps API is loaded.
// Before that, a loading bar is displayed. Internal bookkeeping prevents the API from being loaded multiple times.

let googleMapsStatus = "initial";

// Callback passed to the loaded script.
function afterGoogleMapsLoaded() {
  googleMapsStatus = "loaded";
  window.afterGoogleMapsLoaded = afterGoogleMapsLoaded; // Reset the list for the garbage collector.
}
window.afterGoogleMapsLoaded = afterGoogleMapsLoaded;

export default function withGoogleMaps(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      if (googleMapsStatus === "loaded") {
        this.state = {
          loaded: true,
        };
      } else {
        this.state = {
          loaded: false,
        };
        const nextCallback = window.afterGoogleMapsLoaded;
        window.afterGoogleMapsLoaded = () => {
          // Add this element to the chain of those waiting.
          this.setState({ loaded: true });
          nextCallback();
        };
        if (googleMapsStatus === "initial") {
          // Start the loading process.
          googleMapsStatus = "loading";
          let script = document.createElement("script");
          script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&callback=afterGoogleMapsLoaded`;
          document.head.appendChild(script);
        }
      }
    }

    render() {
      if (this.state.loaded) {
        return <Component {...this.props} />;
      } else {
        return <Loader text="Loading Google Maps..." />;
      }
    }
  };
}